export default "__VITE_ASSET__qhcBUdok__"